import { createUseInfiniteQuery } from "eddev/hooks";
import { UseInfiniteBlogPostsSearchQuery, UseInfiniteBlogPostsSearchQueryVariables } from "../types.graphql";

/**
 * DO NOT EDIT
 * This file is automatically generated by eddev
 * Any changes will be overwritten
 */

export const useInfiniteBlogPostsSearch = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteBlogPostsSearchQuery["blogPosts"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteBlogPostsSearchQueryVariables
>({
  name: "UseInfiniteBlogPostsSearch",
  defaultLimit: 8,
  paths: {
    "nodesPath": ["blogPosts", "nodes"],
    "pageInfoPath": ["blogPosts", "pageInfo"],
    "endCursorPath": ["blogPosts", "pageInfo", "endCursor"],
    "hasNextPagePath": ["blogPosts", "pageInfo", "hasNextPage"],
  },
});
